import * as types from '@/store/mutation-types';

const mutations = {
  [types.ADD_CAROUSEL_IMAGE](state, p) {
    const drp = p.drp;
    drp.images.push(p.newImage);
  },
  [types.REMOVE_CAROUSEL_IMAGE](state, p) {
    const drp = p.drp;
    drp.images.splice(p.imgIndex, 1);
  },
  [types.SET_CAROUSEL_DELAY](state, p) {
    const drp = p.drp;
    drp.delay = p.delay;
  },
  [types.SET_CAROUSEL_VISIBLE_NUM](state, p) {
    const drp = p.drp;
    drp.visible = p.visible;
  },
  [types.SET_CAROUSEL_CONTROLS](state, p) {
    const drp = p.drp;
    drp.controls = p.controls;
  },
  [types.SET_CAROUSEL_LIMITS](state, p) {
    const drp = p.drp;
    drp.itemLimit = p.itemLimit;
    drp.showAll = p.showAll;
  },
  [types.SET_CAROUSEL_FIRST](state, p) {
    const drp = p.drp;
    drp.firstUpload = p.value;
    // if changing to first upload, clear images
    if (p.value) {
      drp.images = [];
    }
  },
};

const actions = {
  addCarouselImage: ({ commit }, payload) => {
    commit(types.ADD_CAROUSEL_IMAGE, payload);
  },
  removeCarouselImg: ({ commit }, payload) => {
    commit(types.REMOVE_CAROUSEL_IMAGE, payload);
  },
  setCarouselDelay: ({ commit }, payload) => {
    commit(types.SET_CAROUSEL_DELAY, payload);
  },
  setCarouselVisibleNum: ({ commit }, payload) => {
    commit(types.SET_CAROUSEL_VISIBLE_NUM, payload);
  },
  setCarouselControls: ({ commit }, payload) => {
    commit(types.SET_CAROUSEL_CONTROLS, payload);
  },
  setCarouselLimits: ({ commit }, payload) => {
    commit(types.SET_CAROUSEL_LIMITS, payload);
  },
  setCarouselFirst: ({ commit }, payload) => {
    commit(types.SET_CAROUSEL_FIRST, payload);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/carousel/vuex.js